/* Add mapping of each entity with its label and date
 array[0] represents entity label
 array[1] represents date label*/
export default {
  entityMappings: {
    medication: ['Medication', 'Start Date'],
    laboratory: ['Result', 'Specimen collection date'],
    vitals: ['Vital', 'Date measure'],
    observation: ['Obs', 'Date taken'],
    allergy: ['Substance', 'Start Date/Date reported'],
    condition: ['Condition', 'Start Date'],
    procedure: ['Procedure', 'Procedure Date'],
    immunization: ['Immunization', 'Immunization Date']
  }
}
